import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import { Provider, inject, observer } from 'mobx-react';
import store from '../store';

import Header from 'components/Header/Header';
import MainPage from './MainPage/MainPage';
import ViewCustomerCase from './ViewCustomerCase/ViewCustomerCase';
import CreateNewCase from './CreateNewCase/CreateNewCase';
import LoginPage from './LoginPage/LoginPage';
import CreateUser from './CreateUser/CreateUser';
import EditUser from './EditUser/EditUser';
import TemplateList from './TemplatesList/TemplatesList';
import CreateTemplate from './CreateTemplate/CreateTemplate';
import EditTemplate from './EditTemplate/EditTemplate';
import AuthWithKey from './AuthWithKey/AuthWithKey';

import { SnackbarProvider } from 'notistack';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';

import styles from './App.css';
import Users from './Users/Users';

import text from '../texts/translations';

import permissions from '../permissions';

// Router configuration
const User = permissions.UserComponent;
const Manager = permissions.ManagerComponent;
const Admin = permissions.AdminComponent;

const theme = createMuiTheme({
  typography: {
    subheading: {
      fontWeight: 500
    }
  },
  palette: {
    primary: {
      main: process.env.REACT_APP_PRIMARY_COLOR
    }
  }
});

export default class App extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <BrowserRouter>
        <MuiThemeProvider theme={theme}>
          <SnackbarProvider maxSnack={3}>
            <Provider {...store}>
              <div>
                <Header />
                <Grid container spacing={8} style={styles.contentGrid}>
                  <Route exact path="/" component={LoginPage} />
		<Route exact path="/auth/:key" component={AuthWithKey} />
	    		<Route exact path="/cases" component={User(MainPage)} />

                  <Route exact path="/create/user" component={Admin(CreateUser)} />
                  <Route exact path="/users" component={Admin(Users)} />
                  <Route exact path="/users/:id" component={Admin(EditUser)} />
                  <Route exact path="/create/template" component={Admin(CreateTemplate)} />
                  <Route exact path="/templates" component={Admin(TemplateList)} />
                  <Route exact path="/templates/:id" component={Admin(EditTemplate)} />
                  <Route
                    exact
                    path="/case/:id"
                    component={User(ViewCustomerCase)}
                  />
                  <Route
                    exact
                    path="/case/create/:id"
                    component={Manager(CreateNewCase)}
                  />
                </Grid>
              </div>
            </Provider>
          </SnackbarProvider>
        </MuiThemeProvider>
      </BrowserRouter>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/App.jsx